import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Form, Dropdown, Flag } from "semantic-ui-react";
import { appStore } from "../stores/AppStore";
import { error } from "@glg/cm-shared-lib/browser/logging";
import { getUserLocaleCountry } from "../lib/locale";

// delete propTypes to silence name warnings, semantic-ui doesn't have all the flags
// we'll use react-tel-input's instead
/* eslint-disable react/forbid-foreign-prop-types */
delete Flag.propTypes;

let _cachedCountries = [];
const fetchCountries = async () => {
  if (_cachedCountries.length > 0 ) {
    return _cachedCountries;
  }
  try {
    let countries = appStore.countries;
    countries = countries.map(c => ({ text: c.text, value: c.id, flag: c.code.toLowerCase(), key: c.code }))
    countries.sort((a, b) => a.text.localeCompare(b.text));
    //Attempt to find user's country to move to top of country list
    const userCountry = getUserLocaleCountry()
    if (userCountry) {
      const preferredIndex = countries.findIndex((c) => c.text === userCountry);
      if (preferredIndex) {
        countries.unshift(<Dropdown.Divider key="divider-country" />);
        countries.unshift(countries.splice(preferredIndex + 1, 1)[0]);
      }
    }


    if (countries.length > 0) {
      _cachedCountries = countries;
    }
    return _cachedCountries;
  } catch (ex) {
    error('fetchCountries', ex)
    return []
  }
}

export const FormCountry = () => {

    const [t] = useTranslation()
    const [countries, setCountries] = useState([])
    useEffect(() => {
        const loadCountries = async () => {
            const options = await fetchCountries()
            setCountries(options);
          }

          loadCountries();
    }, [])

    return (
        <Form.Field>
            <Dropdown
                /** react-tel-input has more flags than semantic-ui */
                className="react-tel-input"
                placeholder={t('select_country') + " *"}
                scrolling
                search
                selection
                name="country"
                options={countries}
                onChange={(e, v) => appStore.countryCodeId = v.value}
                />
        </Form.Field>
    )
}

